import { render, staticRenderFns } from "./HelpdeskTicketsCell.vue?vue&type=template&id=71a16bb0&"
import script from "./HelpdeskTicketsCell.vue?vue&type=script&lang=js&"
export * from "./HelpdeskTicketsCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports